import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCatalogTypes = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGTYPE}`, "get");
    const body = await resp.json();

     debugLogActions(':: catalogTypeActions, startLoadingCatalogTypes', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogTypes(body.catalogTypes));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogTypes = (catalogTypes) => ({
  type: types.CATALOG_TYPE_START_LOADING,
  payload: catalogTypes,
});

export const startLoadingCatalogTypesPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGTYPE}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: catalogTypeActions, startLoadingCatalogTypesPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCatalogTypePaginated(body.catalogTypePaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCatalogTypePaginated = (catalogTypePaginated) => ({
  type: types.CATALOG_TYPE_START_LOADING_PAGINATED,
  payload: catalogTypePaginated,
});

export const selectCatalogTypes = (catalogType) => ({
  type: types.CATALOG_TYPE_SELECT,
  payload: catalogType,
});

export const catalogTypeClean = () => ({
  type: types.CATALOG_TYPE_CLEAN,
});

export const catalogTypeStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOGTYPE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: catalogTypeActions, catalogTypeStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(catalogTypeDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogTypeActions, catalogTypeStartDelete', { 'error': error });
    }
  };
};

const catalogTypeDeleted = (id) => {
  return {
    type: types.CATALOG_TYPE_DELETE,
    payload: id,
  };
};

export const startSearchingCatalogTypesPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGTYPE}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: catalogTypeActions, startSearchingCatalogTypePaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingCatalogTypesPaginated(body.catalogTypesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCatalogTypesPaginated = (catalogTypesPaginated) => ({
  type: types.CATALOG_TYPE_START_SEARCH_PAGINATED,
  payload: catalogTypesPaginated,
});

export const cleanSearchingCatalogTypesPaginated = () => ({
  type: types.CATALOG_TYPE_CLEAN_SEARCH_PAGINATED,
});

export const catalogTypeStartUpdate = (catalogType, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_CATALOGTYPE}`,
        `update/${catalogType.id}`,
        catalogType,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: catalogTypeActions, catalogTypeStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(catalogTypeUpdated(catalogType));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-catalog-type");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogTypeActions, catalogTypeStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} catalogType
 * @returns
 */
const catalogTypeUpdated = (catalogType) => {
  return {
    type: types.CATALOG_TYPE_UPDATE,
    payload: catalogType,
  };
};

export const catalogTypeStartRegister = (catalogType, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_CATALOGTYPE}`,
      "add",
      catalogType,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: catalogTypeActions, catalogTypeStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(catalogTypeRegister(body.catalogType));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-catalog-type");
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const catalogTypeRegister = (catalogType) => ({
  type: types.CATALOG_TYPE_START_REGISTER,
  payload: catalogType,
});

export const catalogTypeSetSearchText = (searchText) => ({
  type: types.CATALOG_TYPE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const catalogTypeCleanSearchText = () => ({
  type: types.CATALOG_TYPE_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingCatalogTypesAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_CATALOGTYPE}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCatalogTypeAll(body.catalogTypes));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingCatalogTypeAll = (catalogTypes) => ({
  type: types.CATALOG_TYPE_START_LOADING_ALL,
  payload: catalogTypes,
});
